// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cYT8x7IWrxQqhu {
  position: relative;
  width: 100%;
  max-width: 850px;
  margin: var(--ds-space-0, 0) auto;
  padding: var(--ds-space-400, 32px);
}
.cYT8x7IWrxQqhu h2 {
  font-size: 16px;
  line-height: 1;
}
.diQbqiL6iDCcRh {
  position: relative;
  margin-bottom: var(--ds-space-300, 24px);
}
.NsO3Hb1wbjvld5 {
  position: relative;
  margin: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-050, 4px) var(--ds-space-500, 40px);
  padding: var(--ds-space-100, 8px) var(--ds-space-0, 0);
}
.d9aDy53gzsedVT {
  position: absolute;
  top: var(--ds-space-075, 5px);
  left: -35px;
}
`, ""]);
// Exports
export var activityContainer = `cYT8x7IWrxQqhu`;
export var windowModule = `diQbqiL6iDCcRh`;
export var windowModuleTitle = `NsO3Hb1wbjvld5`;
export var windowModuleTitleIcon = `d9aDy53gzsedVT`;
export default ___CSS_LOADER_EXPORT___;
